export default __webpack_public_path__ + "static/media/img_0.d570e87b.png";